<template lang="pug">
div
  j-master-dialog(
    ref='master_dialog',
    :background-color='"#007167"',
    :color-text='"white"',
    :height='"80vh"',
    :hide-fields='hideFields',
    :is-add='isAdd',
    :is-on-mobile='isOnMobile',
    :label='isAdd ? $t("item.add") : $t("item.edit")',
    :label-name='$t("common.name")',
    :loading='loading',
    :master-data='itemData',
    :show='show'
    type='item'
    @on-close='closeDialog'
    @on-create='createItem'
    @on-update='updateItem')
    template(#middle)
      validation-observer(ref='observer' v-slot='{invalid}')
        v-text-field#eng_name(v-model='itemData.eng_name' v-next-focus, :label='$t("common.eng_name")')
        v-autocomplete#supplier(
          v-model='itemData.supplier_id'
          v-next-focus,
          :filter='(item, queryText, itemText) => filterBySearchString(item, queryText)',
          :items='suppliersList',
          :label='$t("material_family.supplier")'
          clearable
          item-text='name'
          item-value='id')
          template(v-slot:no-data)
            span.pl-5.grey--text {{$t('message.no_data')}}
        v-text-field#color(v-model='itemData.color' v-next-focus, :label='$t("common.color")') 
        v-autocomplete#box_type_id(
          v-model='itemData.box_type_id'
          v-next-focus,
          :filter='(item, queryText, itemText) => filterBySearchString(item, queryText)',
          :items='boxTypeList',
          :label='$t("material_family.box_type")'
          clearable
          item-text='name'
          item-value='id')
          template(v-slot:no-data)
            span.pl-5.grey--text {{$t('message.no_data')}}
        v-autocomplete#size(
          v-model='itemData.size_id'
          v-next-focus,
          :filter='(item, queryText, itemText) => filterBySearchString(item, queryText)',
          :items='sizeList',
          :label='$t("material_family.size")'
          clearable
          item-text='name'
          item-value='id')
          template(v-slot:no-data)
            span.pl-5.grey--text {{$t('message.no_data')}}
        v-autocomplete#bloom(
          v-model='itemData.bloom_id'
          v-next-focus,
          :filter='(item, queryText, itemText) => filterBySearchString(item, queryText)',
          :items='bloomList',
          :label='$t("material_family.bloom")'
          clearable
          item-text='name'
          item-value='id')
          template(v-slot:no-data)
            span.pl-5.grey--text {{$t('message.no_data')}}
</template>
<script>
  import {defineComponent, toRefs, ref, getCurrentInstance, watch, onMounted} from 'vue'
  import {ValidationProvider, ValidationObserver} from 'vee-validate'
  import JMasterDialog from '../JMasterDialog/index'
  import JConfirmDialog from '../JConfirmDialog/index'
  import {api} from '@/plugins'
  import {endpoints, showError, filterBySearchString, getData} from '@/utils'
  import _ from 'lodash'

  const JItemDialog = defineComponent({
    components: {
      JConfirmDialog,
      JMasterDialog,
      ValidationProvider,
      ValidationObserver
    },
    props: {
      show: {type: Boolean, required: true},
      item: {type: Object, required: false, default: null},
      isAdd: {type: Boolean, required: false, default: true},
      prevInput: {type: String, required: false, default: ''},
      isOnMobile: {type: Boolean, required: false, default: false}
    },
    setup(props, {emit}) {
      const {$toast, $root, $refs} = getCurrentInstance().proxy
      const {item} = toRefs(props)
      const suppliersList = ref([])
      const boxTypeList = ref([])
      const sizeList = ref([])
      const bloomList = ref([])
      const loading = ref(false)
      const hideFields = ['code', 'full_name', 'keyword']

      const itemData = ref({})
      const isSuccessAll = ref(true)
      const showConfirmUsedDialog = ref(false)
      const LIST_STATES = ['name', 'eng_name', 'supplier_id', 'box_type_id', 'color', 'size_id', 'bloom_id']

      const closeDialog = () => {
        loading.value = false
        emit('on-close')
        resetValidate()
      }

      const validateElement = async () => {
        const validate = await $refs.observer.validate()
        if (!validate) {
          $toast.error($root.$t('message.check_data_type'))
          return false
        }
        return true
      }

      const resetValidate = async () => {
        const validateName = await $refs.observer
        validateName.reset()
      }

      const createItem = async () => {
        loading.value = true
        if (!(await validateElement())) {
          loading.value = false
          return
        }
        try {
          const {data} = await api.post('/api/material-families', itemData.value)
          if (isSuccessAll.value) $toast.success($root.$t('message.create_successful'))
          emit('on-reload', data)
          closeDialog()
        } catch (e) {
          // if api return duplicate --> show dialog confirm and allow save in db
          showError(e, $toast, $root.$t('message.create_failed'))
        } finally {
          loading.value = false
          await resetValidate()
        }
      }

      const updateItem = async () => {
        loading.value = true
        try {
          const payload = _.pick(itemData.value, LIST_STATES)
          await api.patch('/api/material-families' + `/${itemData.value.id}`, payload)
          if (isSuccessAll.value) $toast.success($root.$t('message.update_successful'))
          emit('on-reload')
          closeDialog()
        } catch (e) {
          // if api return duplicate --> show dialog confirm and allow save in db
          showError(e, $toast, $root.$t('message.update_failed'))
        } finally {
          loading.value = false
        }
      }
      // const confirmUpdate = async () => {
      //   try {
      //     await api.post(`${UPDATE_ENDPOINT}check?id=${itemData.value.id}`)
      //     await updateItem()
      //   } catch (e) {
      //     showConfirmUsedDialog.value = true
      //   }
      // }

      const init = async () => {
        if (props.show) {
          if (props.isAdd) {
            const itemInit = {
              name: props.prevInput,
              eng_name: null,
              supplier_id: null
            }
            itemData.value = JSON.parse(JSON.stringify(itemInit))
          } else {
            itemData.value = JSON.parse(JSON.stringify(item.value))
          }
        }
      }

      const getMasterData = async () => {
        const data = await getData(['suppliers', 'boxTypes', 'sizes', 'blooms'])
        suppliersList.value = data.suppliers
        boxTypeList.value = data.boxTypes
        sizeList.value = data.sizes
        bloomList.value = data.blooms
      }

      onMounted(async () => {
        await getMasterData()
      })
      watch(
        () => props.show,
        () => {
          init()
        }
      )

      return {
        closeDialog,
        loading,
        itemData,
        updateItem,
        createItem,
        showConfirmUsedDialog,
        suppliersList,
        filterBySearchString,
        hideFields,
        boxTypeList,
        sizeList,
        bloomList
      }
    }
  })

  export default JItemDialog
</script>

<style lang="sass" scoped>
  .content
    padding: 10px
  .required
    content: '99'
    color: red
  .list-item
    max-height: 550px
    overflow-y: auto
  .v-list-item
    padding: 0 !important
    min-height: 35px !important

  .item
    display: flex
    align-items: center

  .item .code
    display: inline-block
    width: 100px
    text-align: left
    padding-left: 20px
  .item .name
    display: inline-block
    width: calc(100% - 100px)
    text-align: left
    padding-right: 20px
  .icon-list
    font-size: 20px
    display: inline-block
    justify-content: center
    align-items: center


  .color-btn
    background-color: #bdbdbd
</style>
